function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import Avatar from 'components/Avatar';
import Account from 'modules/Account';
import * as shapes from '../shapes';
import styles from './OrganizationAdmin.pcss';
var _React_PureComponent;
class OrganizationMembershipModalBox extends (_React_PureComponent = React.PureComponent) {
    renderImage() {
        const { organizationMembership } = this.props;
        return /*#__PURE__*/ _jsx("figure", {
            className: styles.avatarFig,
            children: /*#__PURE__*/ _jsx(Avatar, {
                avatarImg: organizationMembership.details.avatar,
                name: [
                    organizationMembership.details.firstName,
                    organizationMembership.details.lastName
                ],
                className: styles.avatar,
                isRound: true
            })
        });
    }
    renderHeader() {
        const { details } = this.props.organizationMembership;
        return /*#__PURE__*/ _jsxs("h3", {
            className: "text--large text--bold mb-2",
            children: [
                details.firstName,
                " ",
                details.lastName
            ]
        });
    }
    renderInfo() {
        const { organizationMembership } = this.props;
        const { scope, details } = organizationMembership;
        return /*#__PURE__*/ _jsxs("p", {
            className: "text--small text--light",
            children: [
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, Account.messages.scopes[scope])),
                " | ",
                details.businessEmail
            ]
        });
    }
    render() {
        const { organizationMembership } = this.props;
        if (!organizationMembership) {
            return null;
        }
        return /*#__PURE__*/ _jsx("div", {
            className: styles.organizationMembershipModalBox,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row align-items-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto",
                        children: this.renderImage()
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col",
                        children: [
                            this.renderHeader(),
                            this.renderInfo()
                        ]
                    })
                ]
            })
        });
    }
}
_define_property(OrganizationMembershipModalBox, "propTypes", {
    // Explicit props
    organizationMembership: shapes.organizationMembership
});
export default withStyles(styles)(OrganizationMembershipModalBox);
